<template>
  <div class="m-2">
    <div class="flex justify-center items-center">
      <div class="w-2/3">
        <div class="flex justify-between items-center">
          <div class="text-4xl text-black">
            {{ assignment.assignmentName }}
          </div>
          <div>
            <div class="flex flex-row justify-end sp-x-1 " @click="launchAssignmentFeedbackSideDrawer()">
              <div class="cursor-pointer text-xl">
                <span>({{ assignmentFeedback.length }})</span>
              </div>
              <div class="flex cursor-pointer">
                <d-icon class="text-3xl" icon="comments" />
              </div>
            </div>
          </div>
        </div>
        <div class="text-black mb-5">
          Due Date: {{ assignment.assignmentDueDate | formatShortDate }}
        </div>
        <div class="mb-5 cursor-pointer" @click="expandedGuidelines = !expandedGuidelines">
          <div class="flex flex-row">
            <d-icon icon="chevron-up" class="expand-icon cursor-pointer  px-3 transform" :class="{'rotate-180': expandedGuidelines}" />
            <div class=" font-bold">
              Guidelines
            </div>
          </div>
          <transition>
            <div v-if="expandedGuidelines" class="px-6 py-4 bg-white  rounded-md shadow-sm">
              <div class="wysiwyg-editor-container" v-html="assignment.assignmentHtmlContent" />
            </div>
          </transition>
        </div>
        <div>
          <div class="cursor-pointer" @click="expandToDos = !expandToDos">
            <div class="flex flex-row">
              <d-icon icon="chevron-up" class="expand-icon cursor-pointer  px-3 transform" :class="{'rotate-180': expandToDos}" />
              <div class=" font-bold">
                Tasks
              </div>
            </div>
          </div>
          <transition>
            <div v-if="expandToDos">
              <ul v-for="todo in assignmentToDos" :key="todo.id" class="width-full list-none">
                <li class="border-gray-300 border-solid mb-2 cursor-pointer">
                  <a :href="(todo.toDoItemPreRequisiteComplete || todo.submitted) ? '/assignments/todo/' + todo.id : 'javascript:;'" class="flex cursor-pointer" :class="{'cursor-default': (!todo.toDoItemPreRequisiteComplete || !todo.submitted)}">
                    <div class="bg-white select-none rounded-md flex flex-1 justify-between items-center p-4 shadow-sm">
                      <div class=" rounded">{{ todo.toDoItemName }}</div>
                      <div>
                        <div class="flex justify-end items-center">
                          <div class="text-black  px-10">
                            {{ todo.toDoItemDueDate | formatShortDate }}
                          </div>
                          <div class="rounded-md w-10 h-10 mt-2 mr-4 bg-white">
                            <d-icon
                              class=""
                              :class="{'text-green-500' : todo.completed}"
                              :icon="toDoStatusIcon(todo)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </transition>
        </div>
        <div v-if="assignmentCanBeSubmitted()" class="flex flex-row justify-around">
          <div class="px-6 py-4 ">
            <p>You've completed all of the requirements!</p>
            <p>You can now submit for review.</p>
          </div>
          <div class="px-6 py-4">
            <d-btn @click="submitAssignmentForReview">
              Submit For Review
            </d-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import FeedbackSideDrawer from '../Assignments/components/FeedbackSideDrawer';

  export default {
    name: 'UserAssignmentsReview',
    parent: true,
    props: {
      user: {
        type: Object,
        default: () => {},
      },
      assignmentId: {
        type: String,
        default: () => '',
      },
    },

    data: () => ({
      assignment: '',
      assignmentFeedback: [],
      assignmentToDos: [],
      expandToDos: true,
      expandedGuidelines: true,
      loadingAssignment: false,
      loadingToDos: false,
      assignmentForm: {
        completed: false,
        submitted: false,
        userId: '',
        assignmentTemplateId: 0,
      },
    }),

    mounted() {
      this.getAssignmentById();
      this.getAssignmentFeedback();
      this.getAssignmentToDos();
    },

    methods: {
      async getAssignmentById() {
        this.loadingAssignment = true;
        try {
          const { data } = await axios.get(
            `/api/user/assignments/${this.assignmentId}`,
          );
          this.assignment = data;
          this.loadingAssignment = false;
        } catch (error) {
          this.$toast.error(error.message.data);
          this.loadingAssignment = false;
        }
      },

      async getAssignmentFeedback() {
        this.loadingAssignment = true;
        try {
          const { data } = await axios.get(
            `/api/assignments/${this.assignmentId}/feedback`,
          );
          this.assignmentFeedback = data;
          this.loadingAssignment = false;
        } catch (error) {
          this.$toast.error(error.message.data);
          this.loadingAssignment = false;
        }
      },

      async getAssignmentToDos() {
        this.loadingAssignment = true;
        try {
          const { data } = await axios.get(
            `/api/user/assignment/to-dos/paged?currentPage=1&pageSize=100&userAssignmentId=${this.assignmentId}`,
          );
          this.assignmentToDos = data.resultItems;
          this.loadingToDos = false;
        } catch (error) {
          this.$toast.error(error.message.data);
          this.loadingToDos = false;
        }
      },

      async submitAssignmentForReview() {
        this.assignmentForm.id = this.assignment.id;
        this.assignmentForm.userId = this.assignment.userId;
        this.assignmentForm.completed = false;
        this.assignmentForm.submitted = true;
        this.assignmentForm.assignmentTemplateId = this.assignment.assignmentTemplateId;
        try {
          await axios.patch(
            `/api/user/assignments/${this.assignmentForm.id}`,
            this.assignmentForm,
          );
          this.getAssignmentToDos();
          this.$toast.open(`${this.assignment.assignmentName} submitted!`);
        } catch (error) {
          this.$toast.error(error.message.data);
        }
      },

      launchAssignmentFeedbackSideDrawer() {
        this.$sideDrawer.open({
          parent: this,
          component: FeedbackSideDrawer,
          props: {
            userId: this.user.id,
            entityId: Number(this.assignmentId),
            type: 'Assignment',
          },
          events: {
            getFeedback: () => this.getAssignmentFeedback(),
          },
        });
      },

      toDoStatusIcon(todo) {
        if (todo.completed) {
          return 'check';
        }
        if (todo.submitted && !todo.completed) {
          return 'clock';
        }
        if (todo.toDoItemPreRequisiteComplete && !todo.submitted) {
          return '';
        }
        return 'lock';
      },

      toDoCanBeSubmitted(todo) {
        return todo.toDoItemPreRequisiteComplete && !todo.submitted;
      },

      toDoUnderReview(todo) {
        return todo.submitted && !todo.completed;
      },
      assignmentCanBeSubmitted() {
        const completedToDos = this.assignmentToDos.filter((t) => t.completed);
        return completedToDos.length === this.assignmentToDos.length;
      },

    },
  };
</script>